import {MetaTitleDesc} from "./meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Природные ресурсы';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>Область богата природными ресурсами. На территории области находится крупнейшее месторождение
                        гранита, который используется для производства строительного щебня. В Столинском районе
                        расположены уникальные месторождения глин, позволяющие производить кирпич с показателем
                        морозостойкости более 100 циклов. Крупнейшее в Беларуси месторождение мела «Хотиславское»,
                        расположенное в Малоритском районе, имеет около 500 млн. тонн запасов. В этом карьере имеется
                        слой чистого кварцевого песка, пригодного для производства изделий из железобетона и
                        силикатобетона.</p>
                    <p>Брестская область – центр Белорусского Полесья, особенностью которого является преобладание
                        водно-болотных местообитаний: открытых низинных болот, озер и рек, пойменных лугов и ивняковых
                        кустарников.</p>
                    <p>Современная флора области насчитывает более 1400 видов растений. Большинство видов - травянистые
                        растения (1243). Современный натуральный растительный покров занимает свыше 55% территории
                        области. На леса приходится 36,9% территории. Наибольшую площадь занимают сосновые леса (60%).
                        Распространены также берёзовые (16,8%), черноольховые (15,1%), дубовые (3,8%), еловые (3,2%)
                        леса. Луга занимают около 600 тыс. га, из них низинные - более 60% от общей площади.</p>
                    <p>В области много уникальных природных комплексов и памятников природы: Национальный парк
                        «Беловежская пуща» заказники «Споровский», «Средняя Припять», «Ольманские болота», «Званец»,
                        «Дикое». Площадь особо охраняемых природных территорий и объектов составляет 13% от общей
                        площади области при среднереспубликанской - 7,9%.</p>
                </div>
            </div>
        </>
    );
};